import {fetchGet, generateEndpoint} from "../../../utils/request";

export const getBsrsFollowUps= async(token) => {
  const url = `${generateEndpoint('getBsrsFollowUps')}`
  return fetchGet(url, token)
}
